import { z } from "zod";
// The steps card both journey tabs share (Rautainfuusio, Asiantuntijatuki):
// labs, the screener, then booking a time somewhere else. Order is the
// server's (the array), copy is the client's (keyed by step id) — the same
// split every other block follows.
export const journeyStepIdSchema = z.enum(["labs", "screener", "booking"]);
/* What the client can do about a step right now, and nothing more:
 *  - `done`        the step's record exists (a submitted screener; a result
 *                  whose collection date is inside the tab's window)
 *  - `in_progress` started, and the client can carry on with it
 *  - `todo`        not started
 *  - `locked`      not actionable yet — booking, before the others are done
 *
 * A completeness state, never an eligibility one: `done` on the labs step
 * says a dated result exists, never what it said. See journey/stage.ts. */
export const journeyStepStateSchema = z.enum(["done", "in_progress", "todo", "locked"]);
export const journeyStepSchema = z.object({
    id: journeyStepIdSchema,
    state: journeyStepStateSchema,
    // Only ever set on the screener step while it's in_progress — the resume
    // line ("Vastasit N kysymykseen. Viimeksi eilen klo 21.40.") needs both. A
    // count and a timestamp, same rule the rest of this file follows: never a
    // measured value.
    answeredCount: z.number().int().nonnegative().optional(),
    lastSavedAt: z.string().nullable().optional(),
});
// What the client parses a step as: an id or state this build has never heard
// of is kept rather than failing the whole surface, and the card renders it as
// nothing — the readHomeBlockSchema rule, applied to steps. Without it every
// step id change forces a client-before-api deploy order.
export const readJourneyStepSchema = journeyStepSchema.extend({
    id: z.string(),
    state: z.string(),
});
